(function(window, angular, undefined) {
    var app = angular.module('formApp');

    app.directive('resize', ['$window', function ($window) {
        return function (scope) {
            //get window width to show hide logos depending on viewport
            scope.width = $window.innerWidth;
            scope.height = $window.innerHeight;
            angular.element($window).bind('resize', function () {
                scope.$apply(function () {
                    scope.width = $window.innerWidth;
                    scope.height = $window.innerHeight;
                });
            });
        };
    }]);

})(window, window.angular);
